import { Suspense } from 'react'
import { Navigate, useParams } from 'react-router-dom'
import SectionTabs from '../../../components/common/SectionTabs.jsx'
import { Loader2 } from 'lucide-react'
import { hasModule } from '../../access/modules.js'
import { useCurrentUser } from '../../../hooks/useCurrentUser.js'
import { CRM_BASES, crmBasePath } from '../bases.js'

/**
 * Bases du CRM d'un groupe du menu, avec des onglets :
 *   « clients »  /dashboard/clients[/:base]       prospects, biens immobiliers, candidats France Travail
 *   « projets »  /dashboard/projets-auto[/:base]  projets auto, relances
 * Sans `group` (anciennes adresses /dashboard/crm/:base) : redirige vers le bon groupe.
 */
export default function CrmPage({ group = null }) {
  const { base: baseKey } = useParams()
  const { user, isLoading } = useCurrentUser()

  if (isLoading) return null

  const accessible = CRM_BASES.filter((b) => !b.module || hasModule(user, b.module))
  if (!group) {
    const target = accessible.find((b) => b.key === baseKey) ?? accessible[0]
    return target ? <Navigate to={`${crmBasePath(target)}${window.location.search}`} replace /> : null
  }
  const bases = accessible.filter((b) => b.group === group)
  const base = bases.find((b) => b.key === baseKey)
  if (!base) {
    return bases.length > 0 ? <Navigate to={`${crmBasePath(bases[0])}${window.location.search}`} replace /> : null
  }

  const Screen = base.component

  return (
    <div>
      <SectionTabs
        label={group === 'projets' ? 'Projets auto' : 'Clients'}
        activeKey={base.key}
        tabs={bases.map((b) => ({ ...b, to: crmBasePath(b) }))}
      />
      <Suspense
        fallback={(
          <div className="flex items-center justify-center py-20 text-ink/50">
            <Loader2 className="h-5 w-5 animate-spin" />
          </div>
        )}
      >
        <Screen />
      </Suspense>
    </div>
  )
}
